import { palette } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled, { css } from 'styled-components';

interface FixedTableOfContentsContainerProps {
  isFixed?: boolean;
  isPastContainer?: boolean;
}

export const tableOfContentsTopPosition = 120;

export const FixedTableOfContentsContainer = styled.div<FixedTableOfContentsContainerProps>`
  height: fit-content;
  width: 360px;
  display: grid;
  grid-row-gap: 1.5rem;

  ${({ isFixed, isPastContainer }) => {
    if (isPastContainer) {
      // Place the table of contents at the end of the article container
      return css`
        position: absolute;
        top: unset;
        bottom: 0;
        left: 0 !important; // This is useful to override the inline styes added by the scroll handler
      `;
    } else if (isFixed) {
      // Keep the table fixed at the left of the screen
      return css`
        position: fixed;
        top: ${tableOfContentsTopPosition}px;

        // Add scroll when smaller screens
        // Reduce the size of the top position + small compensation for spacing
        max-height: calc(100vh - ${tableOfContentsTopPosition}px - 32px);
        overflow-y: auto;
      `;
    }

    return '';
  }}

  @media all and (max-width: ${layout.lg}) {
    width: 320px;
  }

  @media all and (max-width: ${layout.md}) {
    width: 100%;
  }
`;

interface SpacingRelativeContainerProps {
  isSticky?: boolean;
}

export const SpacingRelativeContainer = styled.div<SpacingRelativeContainerProps>`
  width: 100%;
  position: relative;
  display: grid;

  ${({ isSticky }) =>
    !isSticky
      ? ''
      : css`
          height: 100%;
        `}
`;

export const LoadingContainer = styled.div`
  justify-self: center;
  align-self: center;
  margin-top: 2.8em;
`;

export const TableContentContainer = styled.div`
  display: grid;
  grid-row-gap: 0.7rem;
  width: 100%;
  background-color: ${palette.mercury};
  border-radius: 8px;
  box-sizing: border-box;
  justify-self: center;
  align-self: center;
  padding: 3rem 1.875rem 3rem 3.375rem;

  .title-heading h1 {
    text-align: left;
  }

  @media all and (max-width: ${layout.lg}) {
    padding: 3rem 1rem 3rem 2.2rem;
  }

  @media all and (max-width: ${layout.md}) {
    padding: 3rem 1.875rem 3rem 3.375rem;
  }
`;

export const ShareLinksContainer = styled.div`
  width: 100%;
  background-color: ${palette.mercury};
  border-radius: 8px;
  box-sizing: border-box;
  padding: 2rem 2.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 1.5rem;

  svg {
    width: 24px;
    height: 24px;
  }
`;
